import { inject, Injectable, OnDestroy } from '@angular/core';
import { Provider } from '@app/core/services/api/API.service';
import { BehaviorSubject } from 'rxjs';
import { sortJSON, UtilService } from '../../util.service';
import { take } from 'rxjs/operators';
import { ProviderService } from '@app/core/api/services';

@Injectable({
    providedIn: 'root'
})
export class ProvidersService implements OnDestroy {
    private _providers$ = new BehaviorSubject<Provider[]>([]);
    private _loading$ = new BehaviorSubject<boolean>(true);
    private providers: Provider[] = [];
    private subscriptions: any[] = [];
    private _providerService = inject(ProviderService);

    constructor() {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    get providers$() {
        return this._providers$.asObservable();
    }

    get loading$() {
        return this._loading$.asObservable();
    }

    async listProviders() {
        const cached = this._providers$.getValue();
        if (cached?.length > 0) {
            return;
        }

        try {
            this._loading$.next(true);
            this.providers = [];
            this.providers = await this.listProvidersBD();
        } catch (err) {
            console.log(err);
        } finally {
            this._providers$.next(this.providers);
            this._loading$.next(false);
        }
    }

    async findProviderById(id: string): Promise<Provider | undefined> {
        try {
            const providers = await this.providers$.pipe(take(1)).toPromise(); // Take 1 to unsubscribe after getting the value
            return providers.find(provider => provider.id === id);
        } catch (error) {
            console.error('Error finding provider:', error);
            return undefined;
        }
    }

    private async listProvidersBD(): Promise<Provider[]> {
        const result = await this._providerService.listProviders();
        const items: Provider[] = sortJSON(
            result.map((item: Provider) => item),
            'comertial_name',
            'asc'
        );
        return items;
    }
}
